import script from "./TressMobileFilter.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressMobileFilter.vue?vue&type=script&lang=ts&setup=true"

import "./TressMobileFilter.vue?vue&type=style&index=0&id=5047c4ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5047c4ac"]])

export default __exports__